import React, { useEffect, useState } from 'react';
import { Button, Upload, message, Spin, Flex, Modal, Result} from 'antd';
import { UploadOutlined, LoadingOutlined } from '@ant-design/icons';
import { UploadFile, UploadFileStatus, RcFile } from 'antd/es/upload/interface';
import { useDispatch } from 'react-redux';
import { resetMessageShift, resetSuccess, uploadScheduleRequest } from '../slices/shift';
import { useTypedSelector } from '../store';

const UploadSchedule: React.FC = () => {
  const dispatch = useDispatch();
  const [fileList, setFileList] = useState<UploadFile<any>[]>([]);
  const {messageProcess, isLoading, isSuccess} = useTypedSelector((state) =>{
    return {
      messageProcess: state.Shift.message,
      isLoading: state.Shift.pageIsLoading,
      isSuccess: state.Shift.isSuccess
    }
  })

  // useEffect(()=>{setFileList([])},[])
  const handleUpload = () => {
    if (fileList.length === 0) {
      message.warning("Please select a file before uploading.");
      return;
    }

    const formData = new FormData();
    fileList.forEach((file) => {
      if (file.originFileObj) {
        formData.append("data", file.originFileObj as File);
        dispatch(uploadScheduleRequest(formData) as any)
        
      }
    });

    // Simulate upload process
    // message.success("File uploaded successfully!");
    console.log("Uploaded files:", fileList);
  };

  const uploadProps = {
    onRemove: (file: UploadFile<any>) => {
      setFileList((prevFileList) =>
        prevFileList.filter((f) => f.uid !== file.uid)
      );
    },
    beforeUpload: (file: File & RcFile) => {
      const uploadFile: UploadFile<any> = {
        uid: file.uid || file.name, // Gunakan UID atau nama file
        name: file.name,
        status: "done" as UploadFileStatus,
        originFileObj: file,
      };
      setFileList([uploadFile]);
      return false; // Prevent automatic upload
    },
    fileList,
  };


  return (
    <div >
      <Upload {...uploadProps} accept=".xlsx,.xls">
        <Button icon={<UploadOutlined />}
        style={{width:200, marginBottom:20}}
        >Select File</Button>
      </Upload>
      <Button
        type="primary"
        onClick={handleUpload}
        style={{
            backgroundColor: "#217346",  // Warna hijau khas Excel
            borderColor: "#217346",      // Sesuaikan border dengan warna latar belakang
            color: "#fff",
            width:200                // Warna teks putih
          }}
      >
        {!isLoading && <>Upload Schedule</>}
        {isLoading&& <>
          <Flex align="center" gap="middle">
            <Spin indicator={<LoadingOutlined spin />} size="small" />
          </Flex>
        </>}
      </Button>

      <Modal
        open={isSuccess}
        okButtonProps={{style:{display: "none"}}}
        cancelButtonProps={{style:{display: "none"}}}
        closable={false}
      >
        <Result
        status="success"
        title="Upload Schedule Successfully"
        subTitle=""
        extra={[
          <Button type="primary" onClick={()=> {
            setFileList([])
            dispatch(resetSuccess())}}>
            Close
          </Button>
        ]}
        />
      </Modal>
      <Modal
        open={messageProcess.length > 0}
        okButtonProps={{style:{display: "none"}}}
        cancelButtonProps={{style:{display: "none"}}}
        closable={false}
      >
        <Result
        status="warning"
        title="Upload Failed"
        subTitle={messageProcess}
        extra={[
          <Button type="primary" onClick={()=> {
            setFileList([])
            dispatch(resetMessageShift())}}>
            Close
          </Button>
        ]}
        />
      </Modal>
    </div>
    
    
  );
};

export default UploadSchedule;
